import NotFound from './NotFound';
import Layout from './Layout';

const PageNotFound = ({ route, location }) => (
	<Layout {...{ route, location }}>
		<NotFound />
	</Layout>
);

export default PageNotFound;



// WEBPACK FOOTER //
// ./components/PageNotFound.js